import {UyapRequest} from "./UyapRequest";
import {MahkemeBirimleriRow} from "./CommonInterfaces";

export interface MtsIcraAcilisDosyaBilgileriTalep {
    dosyaId: string
}

export interface MtsIcraAcilisDosyaBilgileriCevap {
    mahkemeBirimi: MahkemeBirimleriRow,
    harcMasraf: HarcMasraf,
    sebepList: Array<Sebep>
}

interface Sebep {
    aciklama: string,
    id: string,
    kapatmaTuru: string,
    name: string
}

interface HarcMasraf {
    harcmasrafKodStr: number,
    harcmasrafBedelmiOranmi: string,
    harcMasrafOran: number,
    hesapMiktar: number,
    pesinHarcDusulsunmu: string,
    harcMasrafBaslangicTarihi: string,
    hmDurumu: number,
    hmAktif: boolean,
    isSatirDegisecek: boolean,
    harcMasrafKod: number,
    harcMasrafAdi: string,
    harcMasraf: string,
    harcTip: number,
    gv_tabi: number,
    dv_tabi: number,
    yg_tabi: number
}

export default class MtsIcraAcilisDosyaBilgileri extends UyapRequest<MtsIcraAcilisDosyaBilgileriTalep, MtsIcraAcilisDosyaBilgileriCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return [{"birimAdi":"Ankara Adliye","birimId":"1000937","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},[],{"harcmasrafKodStr":14603,"harcmasrafBedelmiOranmi":"O","harcMasrafOran":0.5,"hesapMiktar":32.30,"pesinHarcDusulsunmu":"H","harcMasrafBaslangicTarihi":"Jan 1, 1983 12:00:00 AM","hmDurumu":0,"hmAktif":false,"isSatirDegisecek":false,"harcMasrafKod":12808,"harcMasrafAdi":"Peşin Harç","harcMasraf":"H","harcTip":2,"gv_tabi":0,"dv_tabi":0,"yg_tabi":0},[{"name":"TEBLIG_IMKANSIZLIGI","id":"0","kapatmaTuru":"1","aciklama":"Tebliğ İmkansızlığı"},{"name":"SURESINDE_TAM_ODEME_YAPMAMA","id":"1","kapatmaTuru":"1","aciklama":"Borcun Tamamının Ödenmemesi"},{"name":"SURESINDE_KISMEN_ODEME_YAPMA","id":"2","kapatmaTuru":"1","aciklama":"Borcun Kısmen Ödenmesi"},{"name":"YETKIYE_ITIRAZIN_KALDIRILMASI","id":"9","kapatmaTuru":"1","aciklama":"Yetkiye İtirazının Kaldırılması"},{"name":"ITIRAZIN_IPTALI_ITIRAZIN_KALDIRILMASI","id":"12","kapatmaTuru":"1","aciklama":"İtirazın İptali / İtirazın Kaldırılması"}],null];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'main/jsp/avukat/mts_icra_acilis_dosya_bilgileri_brd.ajx';
    }

    async parse(data: any): Promise<MtsIcraAcilisDosyaBilgileriCevap> {
        return {
            mahkemeBirimi: data[0],
            harcMasraf: data[2],
            sebepList: data[3]
        }
    }

}